module.exports = __webpack_public_path__ + "img/dhf.9004a11e.png";